import { FlagOutlined } from '@ant-design/icons'
import { Spin, Tabs } from 'antd'
import { padStart } from 'lodash'
import * as R from 'ramda'
import React from 'react'

import { withFlightsData, WithFlightsDataInnerProps } from '../../helpers/firestore'
import { sortedFlightsInRound } from '../../helpers/flights'

import { Flight } from '../../schemas/Flight'
import { Tournament } from '../../schemas/Tournament'

import ViewFlightCard from './ViewFlightCard'

import './FlightsList.css'

type FlightsListProps = WithFlightsDataInnerProps

const FlightsList = ({
  flightsDataLoaded,
  tournament = {} as Tournament,
  flights = [] as Flight[],
  flightsPlayers = {},
}: FlightsListProps) => {
  const rounds = tournament.rounds ? tournament.rounds + (tournament.finalRound ? 1 : 0) : 0

  const panes = R.range(1, rounds + 1).map((round) => {
    const isFinal = tournament.finalRound && round === rounds
    const tabTitle = isFinal ? (
      <span>
        <FlagOutlined />
        Final
      </span>
    ) : (
      padStart(round.toString(), 2, '0')
    )

    return (
      <Tabs.TabPane tab={tabTitle} key={String(round)}>
        {sortedFlightsInRound(round)(flights).map((flight) => {
          return (
            <ViewFlightCard
              key={flight.id}
              flight={flight}
              flightPlayers={flightsPlayers[flight.id] || []}
              flightSize={tournament.flightSize}
            />
          )
        })}
      </Tabs.TabPane>
    )
  })

  const tabs = (
    <div className="FlightsList">
      <Tabs>{panes}</Tabs>
    </div>
  )

  return flightsDataLoaded ? tabs : <Spin>{tabs}</Spin>
}

export default withFlightsData(FlightsList)



// WEBPACK FOOTER //
// ./src/components/flights/FlightsList.tsx